__turbopack_context__.v({
  "active": "AppointmentBookingPanel-module__aCHy7W__active",
  "additionalDays": "AppointmentBookingPanel-module__aCHy7W__additionalDays",
  "availabilityHeading": "AppointmentBookingPanel-module__aCHy7W__availabilityHeading",
  "codeArea": "AppointmentBookingPanel-module__aCHy7W__codeArea",
  "complete": "AppointmentBookingPanel-module__aCHy7W__complete",
  "completeActions": "AppointmentBookingPanel-module__aCHy7W__completeActions",
  "completeSummary": "AppointmentBookingPanel-module__aCHy7W__completeSummary",
  "datesToggle": "AppointmentBookingPanel-module__aCHy7W__datesToggle",
  "dayLabel": "AppointmentBookingPanel-module__aCHy7W__dayLabel",
  "dayRow": "AppointmentBookingPanel-module__aCHy7W__dayRow",
  "empty": "AppointmentBookingPanel-module__aCHy7W__empty",
  "emptyState": "AppointmentBookingPanel-module__aCHy7W__emptyState",
  "error": "AppointmentBookingPanel-module__aCHy7W__error",
  "fieldError": "AppointmentBookingPanel-module__aCHy7W__fieldError",
  "fields": "AppointmentBookingPanel-module__aCHy7W__fields",
  "filters": "AppointmentBookingPanel-module__aCHy7W__filters",
  "form": "AppointmentBookingPanel-module__aCHy7W__form",
  "formActions": "AppointmentBookingPanel-module__aCHy7W__formActions",
  "formGrid": "AppointmentBookingPanel-module__aCHy7W__formGrid",
  "formHeading": "AppointmentBookingPanel-module__aCHy7W__formHeading",
  "identity": "AppointmentBookingPanel-module__aCHy7W__identity",
  "info": "AppointmentBookingPanel-module__aCHy7W__info",
  "locationLabel": "AppointmentBookingPanel-module__aCHy7W__locationLabel",
  "metadata": "AppointmentBookingPanel-module__aCHy7W__metadata",
  "micro": "AppointmentBookingPanel-module__aCHy7W__micro",
  "moreDates": "AppointmentBookingPanel-module__aCHy7W__moreDates",
  "notice": "AppointmentBookingPanel-module__aCHy7W__notice",
  "ownerNotice": "AppointmentBookingPanel-module__aCHy7W__ownerNotice",
  "panel": "AppointmentBookingPanel-module__aCHy7W__panel",
  "picker": "AppointmentBookingPanel-module__aCHy7W__picker",
  "primary": "AppointmentBookingPanel-module__aCHy7W__primary",
  "rangeDisclosure": "AppointmentBookingPanel-module__aCHy7W__rangeDisclosure",
  "rangeFields": "AppointmentBookingPanel-module__aCHy7W__rangeFields",
  "rangeStatus": "AppointmentBookingPanel-module__aCHy7W__rangeStatus",
  "secondaryAction": "AppointmentBookingPanel-module__aCHy7W__secondaryAction",
  "selected": "AppointmentBookingPanel-module__aCHy7W__selected",
  "selectedSummary": "AppointmentBookingPanel-module__aCHy7W__selectedSummary",
  "slot": "AppointmentBookingPanel-module__aCHy7W__slot",
  "slots": "AppointmentBookingPanel-module__aCHy7W__slots",
  "summary": "AppointmentBookingPanel-module__aCHy7W__summary",
  "summaryLabel": "AppointmentBookingPanel-module__aCHy7W__summaryLabel",
  "textButton": "AppointmentBookingPanel-module__aCHy7W__textButton",
  "unselectedCheck": "AppointmentBookingPanel-module__aCHy7W__unselectedCheck",
});
